import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'
import Link from 'components/Link'
import classes from './Breadcrumb.scss'

import MdKeyboardArrowLeft from 'react-icons/lib/md/keyboard-arrow-left'

const Breadcrumb = (props) => {
  const { showCaret, ...childProps } = props

  const Element = (props.to || props.href) && Link || 'span'
  const icon = () => {
    if (!showCaret) return null
    if (showCaret === true) return <MdKeyboardArrowLeft />

    return showCaret
  }

  return <Element className={cx(classes.breadcrumb, { [classes.underline]: props.onClick && classes.underline })} {...childProps}>
    {icon()}
    {props.children}
  </Element>
}

Breadcrumb.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
  showCaret: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.bool
  ])
}

Breadcrumb.defaultProps = {
  showCaret: true
}

export default Breadcrumb



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/Breadcrumb.js